import { errors } from "../../constants";
import { IRideDto } from "../../dto/rides/ride.dto";
import { unique } from "../array.helpers";

export const RIDE_EDIT_FORM_TOP_INFO_SERVER_ERROR_TRANSLATION_KEYS = [
  errors.ride.rideCreateInPastNotPermitted,
  errors.ride.rideUpdateInPastNotPermitted,
  errors.ride.rideEditNewOnlyNotPermitted,
  errors.ride.cannotRemovePassengersFromDifferentUnits,
  errors.ride.cannotRemovePassengersFromDifferentSites,
] as string[];

export const checkIsErrorShowInRideTopInfo = (error: string): boolean => {
  return RIDE_EDIT_FORM_TOP_INFO_SERVER_ERROR_TRANSLATION_KEYS.includes(error);
};

export const getJoinedProductionIds = (
  rideDto: Partial<IRideDto> | undefined,
): number[] => {
  if (!rideDto?.metadata?.passengersInfo?.length) {
    return [];
  }

  const joinedIds = rideDto.metadata.passengersInfo
    .map(passenger => Number(passenger.joinedProductionId))
    .filter(id => id > 0);

  return unique(joinedIds);
};
